import React from 'react';
import Topbar from '../Topbar/Topbar';

const Header = () => {
    return (
        <div>
            <Topbar></Topbar>
        </div>
    );
};

export default Header;